// extracted by mini-css-extract-plugin
export default {"buttonSecondary":"markets__buttonSecondary__VBIXUd","disabled":"markets__disabled__oEEOst","loading":"markets__loading__bNygJc"};